export default __webpack_public_path__ + "static/media/ic-card-sharp.39215bca.svg";